import React, { useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const ProductImagesModal = ({ isOpen, onClose, images, currentIndex, onPrevImage, onNextImage }) => {
  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === "ArrowLeft") {
        onPrevImage();
      } else if (e.key === "ArrowRight") {
        onNextImage();
      } else if (e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener("keydown", handleKeyPress);
    }
    
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [isOpen, onPrevImage, onNextImage, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/90 p-2 sm:p-4"
      onClick={onClose}
    >
      <div className="relative">
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onPrevImage();
          }}
          className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 text-white bg-white/20 hover:bg-white/30 p-1.5 sm:p-2 rounded-full z-10 transition-all"
        >
          <ChevronLeft className="w-5 h-5 sm:w-6 sm:h-6" />
        </button>

        {images.length > 0 && currentIndex < images.length && (
          <img
            src={images[currentIndex].url}
            alt="Product"
            className="max-w-full max-h-[85vh] object-contain px-12 sm:px-16"
            onClick={(e) => e.stopPropagation()}
          />
        )}

        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onNextImage();
          }}
          className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 text-white bg-white/20 hover:bg-white/30 p-1.5 sm:p-2 rounded-full z-10 transition-all"
        >
          <ChevronRight className="w-5 h-5 sm:w-6 sm:h-6" />
        </button>
      </div>
    </div>
  );
};

export default ProductImagesModal;